'use client';

import { styled } from '@linaria/react';
import RelativeNewsCard from '@fe-news/components/molecules/RelativeNewsCard';
import SubTitle from '@fe-news/components/atoms/PopTopic/SubTitle';
import { QuoteGtmEventType } from '@fe-common-ui/Group';
import { PopTopicData } from '@fe-news/constants/pop-topic/type';
import FixedButton from '@fe-news/components/atoms/PopTopic/FixedButton';
import { DEFAULT_POP_TOPIC_DATA_ARRAY } from '@fe-news/constants/pop-topic/default-value';
import { GTMEventKey, CustomEventName } from '@fe-cnyes/fe-common-gtm';
import DynamicPopTopicGroupTagsGroup from '@fe-news/components/atoms/PopTopic/DynamicPopTopicGroupTagsGroup';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 0px 16px 24px 16px;
  position: relative;
`;

const NoRelativeProduction = styled.div`
  width: fit-content;
  padding: 8px;
  border-radius: 6px;
  border: 1px dashed rgba(132, 141, 151, 0.51);
  font-size: 15px;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: #848d97;
  line-height: 1;
`;

type PopTopicCardContentProps = {
  id: number;
  title: string;
  data: PopTopicData[];
  isCarousel?: boolean;
  isMember?: boolean;
};

const PopTopicCardContent: React.FC<PopTopicCardContentProps> = ({
  title,
  id,
  data,
  isCarousel = false,
  isMember = false
}) => {
  const stock = [...new Set(data.flatMap(item => item.stock ?? []))];
  const isShowRelativeProduction = stock.length > 0;
  const dataAddDefault = [...data, ...DEFAULT_POP_TOPIC_DATA_ARRAY];

  const shouldShowFixedButton = !isCarousel && !isMember;

  return (
    <Container>
      {shouldShowFixedButton && <FixedButton id={id} title={title} />}
      <RelativeNewsCard data={dataAddDefault} fontSize={18} isCarousel={isCarousel} isMember={isMember}>
        <SubTitle
          imageUrl='/assets/icons/icon-hot-news.svg'
          title='相關新聞'
          readMoreLink={`/poptopic/${id}`}
          isCarousel={isCarousel}
          gtmEvent={
            isMember
              ? {
                  [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
                  [GTMEventKey.SECTION]: 'News_Category_我的追蹤',
                  [GTMEventKey.CLICK_ITEM]: `追蹤的時事＿看更多`
                }
              : undefined
          }
        />
      </RelativeNewsCard>
      <div>
        <SubTitle imageUrl='/assets/icons/icon-relate-product.svg' title='相關行情' isNeedReadMore={false} />
        {!isShowRelativeProduction && <NoRelativeProduction>#目前無相關行情資料</NoRelativeProduction>}
        {isShowRelativeProduction && (
          <DynamicPopTopicGroupTagsGroup
            gtmEventQuoteType={
              isMember ? QuoteGtmEventType.NEWS_CATEGORY_MY_POP_TOPIC : QuoteGtmEventType.NEWS_CATEGORY_POP_TOPIC
            }
            stock={stock}
            isPopTopic
            height={64}
          />
        )}
      </div>
    </Container>
  );
};

export default PopTopicCardContent;
